import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  ecardsItem: {
    cursor: 'pointer',
    backgroundColor: '#FFF',
    borderRadius: 10,
    height: 150,
    boxShadow:
      '0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)',

    '-webkit-transform': 'translateZ(0)',
    transform: 'translateZ(0)',
    '-webkit-transition-property': '-webkit-transform',
    'transition-property': 'transform, -webkit-transform',
    '-webkit-transition-duration': '300ms',
    'transition-duration': '300ms',
    '&:hover': {
      '-webkit-transform': 'scale(1.05)',
      '-ms-transform': 'scale(1.05)',
      transform: 'scale(1.05)',
    },
    overflow: 'hidden',
  },
  ecardsDesignItem: {
    width: '100%',
    height: '100%!important',
    objectFit: 'cover',
  },
}));

export interface EcardsDesignItemProps {
  designImage: string,
  selected: boolean,
  onClick: () => void,
}

const EcardsDesignItem: React.FC<EcardsDesignItemProps> = ({
  designImage, selected, onClick,
}) => {
  const { classes } = useStyles();

  return (
    <div
      role="button"
      tabIndex={-1}
      className={classes.ecardsItem}
      style={{
        border: selected && 'solid #ffffff',
      }}
      onClick={onClick}
      onKeyDown={onClick}
    >
      <img
        alt="choose gift card design variant"
        className={classes.ecardsDesignItem}
        src={designImage}
      />
    </div>
  );
};

export default EcardsDesignItem;
